import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';

@Component({
  selector: 'autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent {
  public id: string;
  public toggleState: boolean;
  public searchQuery: string;
  @Input() public allItems: Array<any>;
  public filteredItems: Array<any>;
  @Input() public selectedItems: Array<any>;
  public highlightedItem: any;
  @Input() public placeholder: string;
  @Input() public key: string;
  @Input() public isWideDropdown: boolean;
  @Input() public allowRemoving: boolean;
  @Input() public linksPrefix: string;
  @Input() public newItemSettings: any;
  @Input() public maxItemsToDisplay: number;
  @Output() public onChange: EventEmitter<Array<any>>;

  constructor(public sharedService: SharedService, public dictionaryService: DictionaryService) {
    this.id = 'autocompleteInput_' + new Date().getTime() + '_' + Math.round(Math.random() * 9999);
    this.toggleState = false;
    this.searchQuery = '';
    this.allItems = [];
    this.filteredItems = [];
    this.selectedItems = [];
    this.highlightedItem = null;
    this.placeholder = this.dictionaryService.get('SELECT');
    this.key = 'name';
    this.allowRemoving = true;
    this.linksPrefix = null;
    this.newItemSettings = null;
    this.maxItemsToDisplay = 300;
    this.onChange = new EventEmitter<Array<any>>();
  }

  addItem($event: any) {
    this.selectedItems.push($event);
    this.onChange.emit(this.selectedItems);
    this.searchQuery = '';
    this.updateSuggestionsList(null);
  }

  removeItem($event: any) {
    this.selectedItems.splice(this.selectedItems.indexOf($event), 1);
    this.updateSuggestionsList(null);
    this.onChange.emit(this.selectedItems);
  }

  updateSuggestionsList($event: any) {
    const filteredItems: Array<any> = [];
    let matchedQueryString: boolean;
    let notSelected: boolean;
    const key: string = this.key;
    let i = 0;
    let currItem: any;
    if (this.newItemSettings !== null) {
      filteredItems.push({
        [key]: this.newItemSettings.label,
        isNewItem: true,
      });
    }
    this.searchQuery = this.searchQuery.trim();

    while (filteredItems.length < this.maxItemsToDisplay) {
      if (this.allItems[i]) {
        currItem = _.cloneDeep(this.allItems[i]);
        matchedQueryString = this.sharedService.isEmpty(this.searchQuery)
          ? true
          : this.allItems[i][key].toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1;
        notSelected =
          _.find(this.selectedItems, (selectedItem: any) => {
            return selectedItem[key] === this.allItems[i][key];
          }) === undefined;
        if (matchedQueryString && notSelected) {
          currItem.isNewItem = false;
          filteredItems.push(currItem);
        }
        i++;
      } else {
        break;
      }
    }

    this.filteredItems = filteredItems;
  }

  onInputFocus() {
    this.updateSuggestionsList(null);
    this.toggleState = true;
  }

  onKeyDown($event: any) {
    let index;
    if (!this.sharedService.isEmpty(this.highlightedItem)) {
      index = this.filteredItems.indexOf(this.highlightedItem);
    }
    if ($event.which === 38) {
      index = index > 0 ? index - 1 : this.filteredItems.length - 1;
      this.highlightedItem = this.filteredItems[index];
    } else if ($event.which === 40) {
      index = index < this.filteredItems.length - 1 ? index + 1 : 0;
      this.highlightedItem = this.filteredItems[index];
    } else if ($event.which === 13) {
      if (this.highlightedItem !== null) {
        this.highlightedItem.isNewItem
          ? window.open(this.newItemSettings.link, '_blank')
          : this.addItem(this.highlightedItem);
      }
    }
    if (!this.sharedService.isEmpty(this.highlightedItem)) {
      setTimeout(() => {
        const me = document.getElementById(this.id);
        const suggestionsList = me.getElementsByClassName('autocompleteSuggestionsList')[0];
        const autocompleteSuggestionsListItemHighlighted = suggestionsList.getElementsByClassName(
          'autocompleteSuggestionsListItemHighlighted'
        );
        let highlightedItemDiv;
        if (autocompleteSuggestionsListItemHighlighted.length > 0) {
          highlightedItemDiv = <HTMLElement>autocompleteSuggestionsListItemHighlighted[0];
          suggestionsList.scrollTop = highlightedItemDiv.offsetTop;
        }
      }, 200);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick($event: any) {
    let clickedOnDropdown = false;
    let index = 0;
    const path: any =
      $event.path || ($event.composedPath && $event.composedPath()) || this.sharedService.composedPath($event.target);
    /*
      Close autocomplete if clicked outside
    */
    while (!clickedOnDropdown && index < path.length) {
      clickedOnDropdown = path[index].id === this.id;
      if (!clickedOnDropdown) {
        index++;
      }
    }
    if (!clickedOnDropdown) {
      this.toggleState = false;
      this.searchQuery = '';
      this.highlightedItem = null;
    }
  }
}
